import React from 'react';
import { IconProps } from './types';

export const FewTicketsIcon: React.FC<IconProps> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={className}
    >
        <path
            d="M12.3327 9.33333C12.3327 11.6667 10.5767 13.6667 7.99935 13.6667C5.42202 13.6667 3.66602 11.6667 3.66602 9.33333C3.66602 8.13889 4.33268 6.33333 5.99935 5.33333C5.99935 7.33333 5.99935 9.2 7.33268 8.66667C9.13446 7.94596 5.33268 4.66667 7.99935 2C9.33268 6.33333 12.3327 6 12.3327 9.33333Z"
            fill="#261B36"
        />
    </svg>
);
